'use client';

import { COMMON } from '@/copyright/common';

const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-xs focus:text-sm focus:font-semibold"
    >
      {COMMON.skipToContent}
    </a>
  );
};

export default SkipToContent;
